export const STRAPI_ATTRIBUTES_ACTIVITY_DISCIPLINE = {
  // Hiking
  hiking: 'mountainHiking',
  wandern: 'mountainHiking',
  randonnee: 'mountainHiking',
  escursionismo: 'mountainHiking',

  // Horse Riding
  'horse-riding': 'horseRiding',
  reiten: 'horseRiding',
  equitation: 'horseRiding',
  equitazione: 'horseRiding',

  // Mountain Biking
  'mountain-biking': 'mountainBiking',
  mountainbike: 'mountainBiking',
  vtt: 'mountainBiking',
  mtb: 'mountainBiking',

  // Mountaineering
  mountaineering: 'mountaineering',
  bergsteigen: 'mountaineering',
  alpinisme: 'mountaineering',
  alpinismo: 'mountaineering',

  // Rock Climbing
  'rock-climbing': 'rockClimbing',
  klettern: 'rockClimbing',
  escalade: 'rockClimbing',
  arrampicata: 'rockClimbing',

  // Via Ferrata
  'via-ferrata': 'viaFerrata',
  klettersteig: 'viaFerrata',
  'vie-ferrate': 'viaFerrata',

  // Bouldering
  bouldering: 'bouldering',
  bouldern: 'bouldering',
  bloc: 'bouldering',
  boulder: 'bouldering',

  // Rafting
  rafting: 'rafting',

  // Canyoning
  canyoning: 'canyoning',

  // Paragliding
  paragliding: 'paragliding',
  gleitschirmfliegen: 'paragliding',
  parapente: 'paragliding',
  parapendio: 'paragliding',

  // Guided Walking
  'guided-walking': 'guidedWalking',
  'gefuehrte-wanderungen': 'guidedWalking',
  'randonnee-guidee': 'guidedWalking',
  'passeggiata-guidate': 'guidedWalking',

  // Food & Wine Walking
  'food-and-wine-walking': 'culinaryTasting',
  'essen-und-wein-wandern': 'culinaryTasting',
  'randonnees-gastronomiques-et-oenologiques': 'culinaryTasting',
  'passeggiate-gastronomiche-enogastronomiche': 'culinaryTasting',

  // E-Biking
  'e-biking': 'eBiking',
  'e-biken': 'eBiking',
  'velo-electrique': 'eBiking',
  'e-bike': 'eBiking',

  // Trail Running
  'trail-running': 'trailRunning',
  trailrunning: 'trailRunning',
  trail: 'trailRunning',

  // Cross Country Skiing
  'cross-country-skiing': 'crossCountrySkiing',
  langlaufen: 'crossCountrySkiing',
  'ski-de-fond': 'crossCountrySkiing',
  'sci-di-fondo': 'crossCountrySkiing',

  // Road Cycling
  'road-cycling': 'roadCycling',
  strasenradfahren: 'roadCycling',
  'cyclisme-sur-route': 'roadCycling',
  'ciclismo-su-strada': 'roadCycling',

  // Stand Up Paddle
  'stand-up-paddle': 'standUpPaddle',

  // Kayaking
  kayaking: 'kayaking',
  kajakfahren: 'kayaking',
  kayak: 'kayaking',

  // Sailing
  sailing: 'sailing',
  segeln: 'sailing',
  voile: 'sailing',
  vela: 'sailing',

  // Yoga
  yoga: 'yoga',

  // Tennis
  tennis: 'tennis',

  // Padel
  padel: 'padel',

  // Husky Sledding
  'husky-sledding': 'huskySledding',
  'husky-rodeln': 'huskySledding',
  'traineau-husky': 'huskySledding',
  'slitta-ad-husky': 'huskySledding',

  // Northern Lights
  'northern-lights': 'northernLights',
  nordlicht: 'northernLights',
  'aurores-boreales': 'northernLights',
  'aurora-boreale': 'northernLights',

  // Alpine Skiing
  'alpine-skiing': 'alpineSkiing',
  skifahren: 'alpineSkiing',
  'ski-alpin': 'alpineSkiing',
  'sci-alpino': 'alpineSkiing',

  // Freeride Skiing
  'freeride-skiing': 'freerideSkiing',
  'freeride-skifahren': 'freerideSkiing',
  'ski-freeride': 'freerideSkiing',
  'sci-freeride': 'freerideSkiing',

  // Ski Touring
  'ski-touring': 'skiTouring',
  skitouren: 'skiTouring',
  'ski-de-randonnee': 'skiTouring',
  'sci-alpinismo': 'skiTouring',

  // Telemark Skiing
  'telemark-skiing': 'telemarkSkiing',
  'telemark-skifahren': 'telemarkSkiing',
  'telemark-ski': 'telemarkSkiing',
  'telemark-sci': 'telemarkSkiing',

  // On Piste Snowboarding
  'on-piste-snowboarding': 'onPisteSnowboarding',
  'on-piste-snowboarden': 'onPisteSnowboarding',
  'snowboard-sur-piste': 'onPisteSnowboarding',
  'snowboard-su-pista': 'onPisteSnowboarding',

  // Freeride Snowboarding
  'freeride-snowboarding': 'freerideSnowboarding',
  'freeride-snowboarden': 'freerideSnowboarding',
  'freeride-snowboard': 'freerideSnowboarding',

  // Splitboarding
  splitboarding: 'splitBoarding',
  splitboard: 'splitBoarding',

  // Ice Climbing
  'ice-climbing': 'iceClimbing',
  eisklettern: 'iceClimbing',
  'escalade-sur-glace': 'iceClimbing',
  'arrampicata-su-ghiaccio': 'iceClimbing',

  // Tobogganing
  tobogganing: 'tobogganing',
  rodeln: 'tobogganing',
  luge: 'tobogganing',
  slittino: 'tobogganing',

  // Avalanche Training
  'avalanche-training': 'avalancheTraining',
  lawinentraining: 'avalancheTraining',
  'formation-avalanche': 'avalancheTraining',
  'addestramento-valanghe': 'avalancheTraining',

  // Snowshoeing
  snowshoeing: 'snowShoeing',
  schneeschuhwandern: 'snowShoeing',
  'raquettes-neige': 'snowShoeing',
  ciaspolata: 'snowShoeing',

  // Fat Biking
  'fat-biking': 'fatBiking',
  fatbiken: 'fatBiking',
  'fat-bike': 'fatBiking',

  // Freestyle Skiing
  'freestyle-skiing': 'freestyleSkiing',
  freestyleskifahren: 'freestyleSkiing',
  'ski-freestyle': 'freestyleSkiing',
  'sci-freestyle': 'freestyleSkiing',

  // Heli Skiing
  'heli-skiing': 'heliSkiing',
  heliskifahren: 'heliSkiing',
  'heli-ski': 'heliSkiing',
  'heli-sci': 'heliSkiing',

  // Grass Skiing
  'grass-skiing': 'grassSkiing',
  grasskifahren: 'grassSkiing',
  'grass-ski': 'grassSkiing',
  'sci-erba': 'grassSkiing',

  // Freestyle Snowboarding
  'freestyle-snowboarding': 'freestyleSnowboarding',
  freestylesnowboarden: 'freestyleSnowboarding',
  'snowboard-freestyle': 'freestyleSnowboarding',

  // Heli Boarding
  'heli-boarding': 'heliBoarding',
  heliboarden: 'heliBoarding',
  'heli-board': 'heliBoarding',

  // Horse Carriage Sledding
  'horse-carriage-sledding': 'horseCarriageSledding',
  'pferdeschlittenfahrt': 'horseCarriageSledding',
  'traîneau-cheval': 'horseCarriageSledding',
  'slitta-a-cavallo': 'horseCarriageSledding',

  // Snowmobiling
  snowmobiling: 'snowMobiling',
  snowmobilfahren: 'snowMobiling',
  motoneige: 'snowMobiling',
  motoslitta: 'snowMobiling',

  // Fishing
  fishing: 'fishing',
  angeln: 'fishing',
  peche: 'fishing',
  pesca: 'fishing',

  // Boat Cruising
  'boat-cruising': 'boatCruise',
  bootfahren: 'boatCruise',
  'bateau-croisiere': 'boatCruise',
  'crociera-barca': 'boatCruise',

  // Bungee Jumping
  'bungee-jumping': 'bungeeJumping',
  bungespringen: 'bungeeJumping',
  'saut-a-l-elastique': 'bungeeJumping',
  'salto-bungee': 'bungeeJumping',

  // Skydiving
  skydiving: 'skydiving',
  fallschirmspringen: 'skydiving',
  parachutisme: 'skydiving',
  paracadutismo: 'skydiving',

  // Kiting
  kiting: 'kiting',
  kitefliegen: 'kiting',
  cerfvolant: 'kiting',
  aquilone: 'kiting',

  // Tandem Speed Flying
  'tandem-speed-flying': 'tandemSpeedFlying',
  'tandem-speedflying': 'tandemSpeedFlying',
  'tandem-vitesse-vol': 'tandemSpeedFlying',
  'tandem-velocita-volo': 'tandemSpeedFlying',
};
